import { showWindow } from "../utils/debug"
export default function Contact(){
    showWindow("Contact(): ")
    return <p>This is the Contact page</p>
}